/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import jQuery from 'jquery';
import React from 'react';
import { connect } from 'react-redux';

import i18n from '../../i18n/AdHocBundle.properties';

// @ts-ignore
import { IState, ITitleOptions } from '../store/types/StateTypes';
import * as TitleActions from '../actions/titleActions';

const EMPTY_TITLE_VALUE = i18n['adhoc.title.clickToAddTitleMessage'];

export interface ITitleComponentProps {
    isInDesignerMode: boolean;
    titleOptions: ITitleOptions;
    updateTitleValue: Function;
    updateTitleHeight: Function;
    enterEditableMode: Function;
    leaveEditableMode: Function;
}

const mapStateToProps = (state: IState) => ({
    titleOptions: state.titleOptions,
    isInDesignerMode: state.isInDesignerMode
});

const mapDispatchToProps = (dispatch: Function) => ({
    updateTitleValue: (title: string) => {
        if (title !== EMPTY_TITLE_VALUE) {
            dispatch(TitleActions.changeResourceTitle(title));
        }
    },
    updateTitleHeight: (height: number) => {
        dispatch(TitleActions.changeElementHeight(height));
    },
    enterEditableMode: () => {
        dispatch(TitleActions.enterTitleEditingMode());
    },
    leaveEditableMode: () => {
        dispatch(TitleActions.leaveTitleEditingMode());
    }
});

class TitleComponent extends React.Component<ITitleComponentProps, never> {

    titleRef: any;

    inputRef: any;

    constructor(props: ITitleComponentProps) {
        super(props);

        this.inputRef = React.createRef();
        this.titleRef = React.createRef();

        this.onKeyDown = this.onKeyDown.bind(this);
        this.onTitleChange = this.onTitleChange.bind(this);
    }

    componentDidMount() {
        this.focusTheInput();
        this.checkDynamicProperties();
    }

    componentDidUpdate(prevProps: ITitleComponentProps) {
        this.checkDynamicProperties();
        if (prevProps && prevProps.titleOptions.inEditingMode !== this.props.titleOptions.inEditingMode) {
            this.focusTheInput();
        }
    }

    onTitleChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.props.updateTitleValue(event.target.value);
    }

    onKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
        const key = event.key.toLowerCase();
        if (key === 'escape' || key === 'enter') {
            this.props.leaveEditableMode();
        }
    }

    getTitleToRender() {
        const {
            titleOptions: {
                title,
                inEditingMode
            }
        } = this.props;

        return inEditingMode ? title : title || EMPTY_TITLE_VALUE;
    }

    checkDynamicProperties() {
        if (this.titleRef.current) {
            const titleHeight = jQuery(this.titleRef.current).outerHeight(true);
            if (this.props.titleOptions.domNodeHeight !== titleHeight) {
                this.props.updateTitleHeight(titleHeight);
            }
        }
    }

    focusTheInput() {
        if (this.inputRef.current) {
            this.inputRef.current.focus();
            this.inputRef.current.select();
        }
    }

    editableTitle() {
        const title = this.getTitleToRender();

        return (
            <div ref={this.titleRef} className="jr-mAdhoc-visualization-title jr jr-jAdhocVisualizationTitle">
                <input
                    ref={this.inputRef}
                    type="text"
                    value={title}
                    className="control input text jr-mAdhoc-visualization-title-text jr jr-jAdhocVisualizationTitleText"
                    onChange={this.onTitleChange}
                    onKeyDown={this.onKeyDown}
                    // @ts-ignore
                    onBlur={this.props.leaveEditableMode}
                />
            </div>
        )
    }

    staticTitle() {
        const {
            titleOptions,
            isInDesignerMode
        } = this.props;

        if (!titleOptions.showTitle) {
            return '';
        }

        if (!isInDesignerMode && !titleOptions.title) {
            return '';
        }

        const title = this.getTitleToRender();

        let clickHandler :any = () => {};
        let editableClass = '';
        if (isInDesignerMode) {
            clickHandler = this.props.enterEditableMode;
            editableClass = 'editable';
        }

        return (
            <div ref={this.titleRef} className="jr jr-jAdhocVisualizationTitle jr-mAdhoc-visualization-title">
                <h2 onClick={clickHandler} className={`jr jr-mAdhoc-visualization-title-text jr-jAdhocVisualizationTitleText ${editableClass}`}>{title}</h2>
            </div>
        )
    }

    render() {
        const {
            titleOptions: {
                inEditingMode
            }
        } = this.props;

        return inEditingMode ? this.editableTitle() : this.staticTitle();
    }
}

const component = connect(mapStateToProps, mapDispatchToProps)(TitleComponent);

export {
    component as TitleComponent
};
